import {
    call,
    put,
    select,
    take,
    takeEvery,
    takeLatest,
} from "redux-saga/effects";
import {
    RATE_UPDATE_SAGA,
    RATE_UPDATE_SUCCESS,
    RATE_UPDATE_FAILURE,
} from "@/Redux/Rate/RateConstants";
import { fetchQuery } from "relay-runtime";
import {
    relayAuthEnvironment,
    relayGuestEnvironment,
} from "@/RelayEnvironment";
import { graphql } from "relay-runtime";
import { RateSagasRateQuery } from "@/Redux/Rate/__generated__/RateSagasRateQuery.graphql";
import { Environment } from "react-relay";

function* updateRates(action: any) {
    try {
        // @ts-ignore
        const data: any = yield fetchQuery(
            // @ts-ignore
            relayAuthEnvironment() as Environment,
            graphql`
                query RateSagasRateQuery {
                    rateList {
                        rates {
                            rate
                            stations {
                                station
                            }
                            rates {
                                rateId
                                groupId
                                description
                                unit
                                price
                                addUnit
                                addPrice
                                kmFree
                                kmAdd
                                deductible
                                inetRate
                            }
                        }
                    }
                }
            `,
            {},
        )
            .toPromise()
            .then((data) => {
                return data;
            })
            .catch((error) => {
                throw error;
            });

        yield put({
            type: RATE_UPDATE_SUCCESS,
            data: data,
        });
    } catch (e: any) {
        yield put({
            type: RATE_UPDATE_FAILURE,
            data: {
                queryResult: [],
            },
        });
    }
}

function* rateSagas() {
    yield takeLatest(RATE_UPDATE_SAGA, updateRates);
}

export default rateSagas;
